import type { ListTileSpec } from "../ListTiles";
import type { ChartChip } from "../ChartChips";
import { pct, fmtCount } from "../listMath";

export interface ContactStats {
  total: number; withEmail: number; engaged: number;
  buyers: number; clients: number; coi: number; prospects: number; capitalProviders: number;
}

export function contactTiles(s: ContactStats): ListTileSpec[] {
  const noEmail = Math.max(0, s.total - s.withEmail);
  return [
    { key: "total", label: "Contacts", value: s.total, sub: noEmail > 0 ? `${fmtCount(noEmail)} have no email` : "every contact has an email" },
    { key: "email", label: "With an email", value: s.withEmail, sub: `${pct(s.withEmail, s.total)}% have an email`,
      coverage: { covered: s.withEmail, total: s.total, title: `${fmtCount(s.withEmail)} with an email` } },
    { key: "engaged", label: "Spoken to", value: s.engaged, sub: `${pct(s.engaged, s.total)}% of contacts`,
      coverage: { covered: s.engaged, total: s.total, title: `${fmtCount(s.engaged)} spoken to` } },
  ];
}

/** Keys are the companies.category values GET /api/contacts?category= matches on. */
export function contactCategoryChips(s: ContactStats): ChartChip[] {
  return [
    { key: "Buyer Network", label: "Buyers", count: s.buyers },
    { key: "Client", label: "Clients", count: s.clients },
    { key: "Prospects", label: "Prospects", count: s.prospects },
    { key: "COI", label: "COI", count: s.coi },
    { key: "Capital Providers", label: "Capital providers", count: s.capitalProviders },
  ];
}
